//@flow
import BaseEntitySelectors from 'common/redux/selectors/BaseEntitySelectors';

class RiderPersonaSelectors extends BaseEntitySelectors {
    constructor() {
        super('riderPersona');
    }
}

export default new RiderPersonaSelectors();
